import React from "react";
import { LanguageContext } from "../Context/LanguageContext";
import { useContext } from "react";
import FooterInfo from "../components/FooterInfo";
import location_icon from "../assets/icons/location_icon.png";
import mail_icon from "../assets/icons/mail_icon.png";
import tel_icon from "../assets/icons/tel_icon.png";
import facebook_icon from "../assets/icons/facebook.png";

export const Footer = () => {
  const { texts, language } = useContext(LanguageContext);

  return (
    <footer
      id="contact"
      className="relative bg-gradient-to-br from-neutral-900 via-black to-neutral-900 text-white overflow-hidden scroll-mt-20 sm:scroll-mt-24"
    >
      {/* Enhanced Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-primary-400 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-80 h-80 bg-primary-500 rounded-full blur-3xl animate-pulse animation-delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-primary-600 rounded-full blur-3xl opacity-30"></div>
      </div>
      
      {/* Grid pattern overlay */}
      <div className="absolute inset-0 opacity-5 bg-[linear-gradient(rgba(139,0,0,0.1)_1px,transparent_1px),linear-gradient(to_right,rgba(139,0,0,0.1)_1px,transparent_1px)] bg-[size:50px_50px]"></div>

      <div className="relative">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 md:py-16">
          <div className="text-center mb-8 sm:mb-12 md:mb-16">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-primary-400/20 backdrop-blur-sm px-4 py-2 rounded-full border border-primary-400/30 mb-6">
              <span className="w-2 h-2 bg-primary-400 rounded-full animate-pulse"></span>
              <span className={`text-white/90 text-xs sm:text-sm font-semibold tracking-wide ${language === 'en' ? 'uppercase' : ''}`}>{texts.badge_get_in_touch}</span>
            </div>

            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-extrabold mb-3 sm:mb-4 md:mb-5 py-3 sm:py-4 leading-relaxed text-white bg-gradient-to-r from-white via-white to-primary-100 bg-clip-text text-transparent">
              <span className="inline-block px-2" style={{ lineHeight: '1.4' }}>
                {texts.footer_text}
              </span>
            </h2>

            {/* Enhanced Contact Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 max-w-6xl mx-auto">
              <div className="relative group">
                <div className="relative bg-white/10 backdrop-blur-md rounded-2xl sm:rounded-3xl p-6 sm:p-8 border border-white/20 transition-all duration-300 shadow-xl min-h-[280px] flex items-center">
                  <div className="flex flex-col items-center text-center w-full">
                    <div className="relative mb-4 sm:mb-6">
                      <div className="absolute inset-0 bg-primary-400/30 rounded-full blur-xl"></div>
                      <div className="relative w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-gradient-to-br from-primary-400 to-primary-600 rounded-full flex items-center justify-center transition-transform duration-300 shadow-2xl">
                        <img
                          className="w-7 h-7 sm:w-8 sm:h-8 md:w-10 md:h-10 object-contain filter brightness-0 invert"
                          src={location_icon}
                          alt="location icon"
                        />
                      </div>
                    </div>
                    <h3 className="text-lg sm:text-xl font-bold mb-2 sm:mb-3 text-primary-300">
                      {texts.card_location}
                    </h3>
                    <p className="text-white/90 text-sm sm:text-base leading-relaxed">
                      {texts.location}
                    </p>
                  </div>
                </div>
              </div>

              <div className="relative group">
                <div className="relative bg-white/10 backdrop-blur-md rounded-2xl sm:rounded-3xl p-6 sm:p-8 border border-white/20 transition-all duration-300 shadow-xl min-h-[280px] flex items-center">
                  <div className="flex flex-col items-center text-center w-full">
                    <div className="relative mb-4 sm:mb-6">
                      <div className="absolute inset-0 bg-primary-400/30 rounded-full blur-xl"></div>
                      <div className="relative w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-gradient-to-br from-primary-400 to-primary-600 rounded-full flex items-center justify-center transition-transform duration-300 shadow-2xl">
                        <img
                          className="w-7 h-7 sm:w-8 sm:h-8 md:w-10 md:h-10 object-contain filter brightness-0 invert"
                          src={mail_icon}
                          alt="email icon"
                        />
                      </div>
                    </div>
                    <h3 className="text-lg sm:text-xl font-bold mb-2 sm:mb-3 text-primary-300">
                      {texts.card_email}
                    </h3>
                    <a
                      href="mailto:info@garo-iq.com"
                      className="text-white/90 text-sm sm:text-base hover:text-primary-300 transition-colors duration-300 font-medium"
                    >
                      info@garo-iq.com
                    </a>
                  </div>
                </div>
              </div>

              <div className="relative group sm:col-span-2 md:col-span-1">
                <div className="relative bg-white/10 backdrop-blur-md rounded-2xl sm:rounded-3xl p-6 sm:p-8 border border-white/20 transition-all duration-300 shadow-xl min-h-[280px] flex items-center">
                  <div className="flex flex-col items-center text-center w-full">
                    <div className="relative mb-4 sm:mb-6">
                      <div className="absolute inset-0 bg-primary-400/30 rounded-full blur-xl"></div>
                      <div className="relative w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-gradient-to-br from-primary-400 to-primary-600 rounded-full flex items-center justify-center transition-transform duration-300 shadow-2xl">
                        <img
                          className="w-7 h-7 sm:w-8 sm:h-8 md:w-10 md:h-10 object-contain filter brightness-0 invert"
                          src={tel_icon}
                          alt="phone icon"
                        />
                      </div>
                    </div>
                    <h3 className="text-lg sm:text-xl font-bold mb-2 sm:mb-3 text-primary-300">
                      {texts.card_phone}
                    </h3>
                    <div className="space-y-2">
                      <a
                        href="tel:07701523385"
                        className="block text-white/90 text-sm sm:text-base hover:text-primary-300 transition-colors duration-300 font-medium"
                      >
                        07701523385
                      </a>
                      <a
                        href="tel:07701561674"
                        className="block text-white/90 text-sm sm:text-base hover:text-primary-300 transition-colors duration-300 font-medium"
                      >
                        07701561674
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4 md:py-5">
            <div className="text-center">
              <p
                className="text-white/60 text-xs sm:text-sm"
                dir="ltr"
              >
                ©{new Date().getFullYear()}{" "}
                <a
                  target="_blank"
                  href="https://garocompany.com"
                  className="text-primary-400 hover:text-primary-300 transition-colors duration-200 font-semibold"
                  rel="noopener noreferrer"
                >
                  Garo Company™
                </a>
                . All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
